import React from "react";

import { Tooltip, TooltipContainer, TooltipContent } from "./styles";
import { IProps } from "./interfaces";

export default ({ children, isSelect }: IProps) => (
    <Tooltip className={isSelect ? "Select" : ""}>
        <TooltipContainer>?</TooltipContainer>
        <TooltipContent className={"Content"}>{children}</TooltipContent>
    </Tooltip>
);
